module.exports = __webpack_public_path__ + "static/media/a.638bf829.png";